var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    rx: 10,
    fill: "#D38CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5792 37.5516H38.9846L38.4195 37.0066C40.3975 34.7056 41.5884 31.7183 41.5884 28.4687C41.5884 21.2225 35.7148 15.3489 28.4686 15.3489C21.2224 15.3489 15.3488 21.2225 15.3488 28.4687C15.3488 35.7148 21.2224 41.5885 28.4686 41.5885C31.7183 41.5885 34.7056 40.3976 37.0066 38.4195L37.5515 38.9847V40.5792L47.6437 50.6512L50.6511 47.6437L40.5792 37.5516ZM28.4686 37.5516C23.4427 37.5516 19.3857 33.4946 19.3857 28.4687C19.3857 23.4428 23.4427 19.3857 28.4686 19.3857C33.4945 19.3857 37.5515 23.4428 37.5515 28.4687C37.5515 33.4946 33.4945 37.5516 28.4686 37.5516Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.64b5e29e19e5509e5f4ac38407caabdc.svg";
export { ForwardRef as ReactComponent };